import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import Select from 'react-select';
import Swal from 'sweetalert2';
import endpoints from '../../../config/endpoints';
import { popupSlice } from "../../../services/reducers";
import { setLoading } from '../../../services/reducers/homeSlice';
import restApi from '../../../services/restApi';
import { useAppSelector } from '../../../services/store';
import alertHandler from '../../../utils/alertHandler';
import tools from '../../../utils/tools';
import LoadingBody from '../../App/loading/LoadingBody';

const StoreDetails = ({ store }) =>{
  const dispatch: any = useDispatch()

  return(
    <main className="billMain billSec heightAuto">
    <span className="blueText billHeader">
      فروشگاه {store.title}
    </span>
    <span className="billDetSpan fontSize">
      <p className="textAlignRight">  {store.phoneNumber}</p>
      <p className="blueText">{store.address}</p>
    </span>
    <span className="billButtons">
      <button className="billButton cancelButton" onClick={() => dispatch(popupSlice.hide())}>تایید</button>
    </span>
    </main>
  )
}
export default StoreDetails